// extracted by mini-css-extract-plugin
export default {"alertContainer":"Alert_alertContainer__IB3Gw","alertText":"Alert_alertText__vHwMv"};